import { useEffect, useState } from 'react'
import { useRouter } from 'next/navigation'

import isClient from '@equifax-ui/utils/browser/isClient'

import { useProposalContext } from '@/context/ProposalContext'

import { getAllParams } from '@/utils/browser'

import { API_FLOW_LABEL } from '@/constants'
import { SOURCE_URL_LABEL } from '@/constants/api'

import {
  E2E_FLOW_DATA,
  ROUTES_OUTSIDE_FORM_STRUCTURE,
  STEPS
} from '@/constants/steps'

export const useNavigation = () => {
  const [urlParams, setUrlParams] = useState('')
  const { setIsLoading, setLeadData } = useProposalContext()

  const router = useRouter()
  const isWindowReady = isClient()

  useEffect(() => {
    if (!isWindowReady) return

    const params = getAllParams()

    setUrlParams(params)
  }, [isWindowReady])

  const getStepRoute = (stepName) => {
    const flowData = JSON.parse(sessionStorage.getItem(API_FLOW_LABEL)) || {}

    const FLOW_STEPS = STEPS[flowData.flow] || {}
    const E2E_STEPS = STEPS[E2E_FLOW_DATA.flow]

    if (ROUTES_OUTSIDE_FORM_STRUCTURE[stepName]) {
      return ROUTES_OUTSIDE_FORM_STRUCTURE[stepName]
    }

    if (FLOW_STEPS[stepName]) return `/formulario/${FLOW_STEPS[stepName]}`
    if (E2E_STEPS[stepName]) return `/formulario/${E2E_STEPS[stepName]}`

    return null
  }

  const redirectStep = (stepName) => {
    const stepRoute = getStepRoute(stepName)

    if (!stepRoute) {
      goBackHome()
      return
    }

    const urlParams = window.location.search || ''

    router.push(`${stepRoute}${urlParams}`)
  }

  const goBackHome = () => {
    setIsLoading(true)

    const sourceURL = sessionStorage.getItem(SOURCE_URL_LABEL)
    const initialRoute = (sourceURL && JSON.parse(sourceURL)) || '/'

    setLeadData({})

    router.replace(initialRoute)
  }

  return {
    urlParams,
    redirectStep,
    goBackHome
  }
}
